<template
  xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <default-view>

    <span slot="header">Instruments</span>

    <p1>Hallo instruments</p1>

    <v-container slot="content">
      <v-row>
        <v-col cols="12">

          <v-card
            :key="instrument.id" v-for="instrument in instrument_list">
            <v-card-title>
              {{instrument.name}}
            </v-card-title>

            <v-card-text>

              <v-select
                label="Type"
                :items="instrumentType_items"
                :value="instrument.type"
                outlined></v-select>

              <v-text-field label="Name" v-model="instrument.name"></v-text-field>
              <v-text-field label="Location" v-model="instrument.location"></v-text-field>
              <v-text-field label="Serial number" v-model="instrument.serial_number"></v-text-field>

              <v-textarea label="Notes" v-model="instrument.notes"></v-textarea>
            </v-card-text>

            <v-card-actions>

              <v-tooltip>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on"
                         @mouseup="btnEdit_click">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit...</span>
              </v-tooltip>

              <v-btn>Edit</v-btn>
            </v-card-actions>


          </v-card>

        </v-col>

      </v-row>
    </v-container>

  </default-view>
</template>

<script>

	import DefaultView from './app/DefaultView'
	import {
		VContainer, VLayout, VRow, VCol, VFlex, VSlot,
		VCard, VCardTitle, VCardText, VCardActions,
		VBtn, VTooltip, VTextField, VTextarea, VIcon,
		VSelect
	} from 'vuetify'

	import {mdiPencil} from '@mdi/js'

	export default {
		name: "instrument-list-view",
		components: {
			DefaultView,
			VContainer, VLayout, VRow, VCol, VFlex, VSlot,
			VCard, VCardTitle, VCardText, VCardActions,
			VBtn, VTooltip, VTextField, VTextarea, VIcon,
			VSelect
		},

		data: function () {
			return {
				instrument_list: []
			}
		}
	}
</script>

<style scoped>

</style>